import { render, staticRenderFns } from "./SpeechAlbumDetail.vue?vue&type=template&id=62faeae8&scoped=true&"
import script from "./SpeechAlbumDetail.vue?vue&type=script&lang=js&"
export * from "./SpeechAlbumDetail.vue?vue&type=script&lang=js&"
import style0 from "./SpeechAlbumDetail.vue?vue&type=style&index=0&id=62faeae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62faeae8",
  null
  
)

export default component.exports